// committees.ts — Endpoints comités (types d'instances de gouvernance).
import { req } from './_internals.js';

export const committeesApi = {
  getCommittees: () => req('GET', '/committees'),
  getCommittee: (id: number | string) => req('GET', '/committees/' + id),
  createCommittee: (d: unknown) => req('POST', '/committees', d),
  updateCommittee: (id: number | string, d: unknown) => req('PUT', '/committees/' + id, d),
  deleteCommittee: (id: number | string) => req('DELETE', '/committees/' + id),
  reorderCommittees: (order: unknown) => req('PUT', '/committees/reorder', order),
};
